<div class="sensors">
  <table mat-table [dataSource]="sensors" class="sensors-list" *ngIf="sensors.length > 0">
    <ng-container matColumnDef="sensorType">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'module.sensorData.sensorListTable.common.sensorType' | translate }}
      </th>
      <td mat-cell *matCellDef="let element" class="sensorType" [ngSwitch]="element.sensor_type | lowercase">
        <!-- <div class="doggo" *ngSwitchCase="dogtoilet">
            <label [ngClass]="{'dog-bag-green': element.dogBags >= 51 ,
                'dog-bag-yellow': element.dogBags < 51 && element.dogBags > 25,
                'dog-bag-red': element.dogBags <= 25}">
              <app-svg-icon class="app-svg-icon" src="./assets/icons/ico_dog_bag.svg"></app-svg-icon>
            </label>
            <label [ngClass]="{'dog-bin-gray': getTrashCanValue(element.dogTrashCan) == 255,
                'dog-bin-green': getTrashCanValue(element.dogTrashCan) < 255 && getTrashCanValue(element.dogTrashCan) > 30,
                'dog-bin-yellow': getTrashCanValue(element.dogTrashCan) <= 30 && getTrashCanValue(element.dogTrashCan) > 20,
                'dog-bin-red': getTrashCanValue(element.dogTrashCan) <= 20}">
              <app-svg-icon class="app-svg-icon" src="./assets/icons/ico_dog_bin.svg"></app-svg-icon>
            </label>
          </div> -->
        <div class="temperature-sensor" *ngSwitchCase="temperature">
          <label
            *ngIf="element.reading[0] !== null"
            [ngClass]="{
              'temperature-primary': element.alarmRuleEnabled === false,
              'temperature-red': element.reading[0].temperature_1 > element.ruleJSON?.tempGt || element.reading[0].temperature_1 < element.ruleJSON?.tempLt,
              'temperature-green': !(element.reading[0].temperature_1 > element.ruleJSON?.tempGt || element.reading[0].temperature_1 < element.ruleJSON?.tempLt)
            }"
          >
            <app-svg-icon class="app-svg-icon" src="./assets/icons/ico_temperature_basic.svg"></app-svg-icon>
          </label>
          <label
            *ngIf="element.reading[0] !== null"
            [ngClass]="{
              'temperature-primary': element.alarmRuleEnabled === false,
              'temperature-red': element.reading[0].temperature_2 > element.ruleJSON?.tempGt || element.reading[0].temperature_2 < element.ruleJSON?.tempLt,
              'temperature-green': !(element.reading[0].temperature_2 > element.ruleJSON?.tempGt || element.reading[0].temperature_2 < element.ruleJSON?.tempLt)
            }"
          >
            <app-svg-icon class="app-svg-icon" src="./assets/icons/ico_temperature_basic.svg"></app-svg-icon>
          </label>
        </div>
        <div class="dioxide -margin-left" *ngSwitchCase="dioxide">
          <app-co2-svg
            class="app-co2-svg"
            [color]="element.currentQuality ? element.currentQuality?.Color : ''"
            [tooltip]="element.currentQuality ? element.currentQuality?.Text : ''"
            [ngClass]="!element.currentQuality ? 'quality-index-inactive' : ''"
          >
          </app-co2-svg>
        </div>
        <div class="-margin-left" *ngSwitchDefault>
          <app-svg-icon *ngIf="element.sensor_type !== null" class="app-svg-icon" [src]="element.image"> </app-svg-icon>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="deviceEUI">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'module.sensorData.sensorListTable.common.sensorNumber' | translate }}
      </th>
      <td mat-cell *matCellDef="let element">{{ element.device_eui }}</td>
    </ng-container>

    <ng-container matColumnDef="locationContext">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'module.sensorData.sensorListTable.common.locationContext' | translate }}
      </th>
      <td mat-cell *matCellDef="let element">
        <div class="text-overflow" [matTooltip]="element.locationContext" appMatTooltipOnEllipsis>
          {{ element.locationContext }}
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="details">
      <th mat-header-cell *matHeaderCellDef>Grafik</th>
      <td mat-cell *matCellDef="let element">
        <a (click)="redirect(element)" class="details-link">
          <span class="fa fa-bar-chart" aria-hidden="true"></span>
          <span class="anchor-label">&nbsp;{{ 'module.sensorData.sensorListTable.common.details' | translate }}</span>
        </a>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

  <app-notification-card
    class="app-notification-card"
    type="info"
    text="{{ 'module.sensorData.common.noResultsFoundText' | translate }}"
    *ngIf="!isLoading && sensors.length <= 0"
  >
  </app-notification-card>

  <div class="sensor-list-loading" *ngIf="isLoading">
    <span class="fa fa-spinner fa-spin fa-3x"></span>
  </div>
</div>
